import { useEffect } from 'react'

import type { TextareaProps } from './textarea.types'

import { vui } from '../core'
import { TextField } from '../textField'

/**
 * @deprecated Use `TextField` with a `rows` prop instead. `Textarea` is a thin wrapper kept for
 * backward compatibility and will be removed in a future major version.
 */
export const Textarea = vui<'div', TextareaProps>((props, ref) => {
  const { resize, rows, textareaProps, textareaRef, ...rest } = props

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[Textarea] is deprecated. Use `TextField` with a `rows` prop instead.')
    }
  }, [])

  return (
    <TextField
      fieldProps={textareaProps}
      fieldRef={textareaRef}
      ref={ref}
      resize={!!resize && resize !== 'none'}
      rows={rows ?? 2}
      {...rest}
    />
  )
})

Textarea.displayName = 'Textarea'

export default Textarea
